import Storage from "../Storage";
import React from "react";

export const Message = {
  DeleteConfirm: { pt: "Você tem certeza de que deseja excluir esse item?", en: "Are you sure you want to delete this item?" },
  Confirm: { pt: "Você tem certeza de que deseja continuar?", en: "Are you sure you want to continue?" },
  DeleteSuccess: { pt: "Removido com sucesso", en: "Successfully removed" },
  Saved: { pt: "Salvo com sucesso", en: "Saved successfully" },
  Save: { pt: "Salvar", en: "Save" },
  PendingData: { pt: "Preencha os dados para poder salvar", en: "Fill in the details to be able to save" },
  PendingInitialTime: { pt: "Preencha o horário de coleta inicial", en: "Fill in the details to be able to save" },
  PendingFinalTime: { pt: "Preencha o horário de coleta final", en: "Fill in the details to be able to save" },
  Delivery: {
    Delivery: { pt: "Entrega", en: "Delivery" },
    Start: { pt: "Pedido de entrega em processamento, em breve o veículo será despachado para a coleta" },
  },
  Company: {
    AlreadyExist: { pt: "Essa empresa já existe, entre em contato com o administrador." }
  },
  Account: {
    PasswordDiferent: { pt: "As senhas não batem" },
    WeakPassword: { pt: "A senha é fraca" },
    TermsNeeded: { pt: "Você precisa aceitar os termos de uso para continuar" },
    AlreadyExist: { pt: "Já existe um usuário com esses dados" },
    SuccessfullyRegistred: { pt: "Cadastrado com sucesso" },
    InvalidDoc: { pt: "CPF/CNPJ inválido" },
    Welcome: { pt: "Bem Vindo!" },
  },
  Login: {
    Welcome: { pt: "Olá, seja bem-vindo!", en: "Welcome!" },
    Recover: { pt: "Recuperar senha", en: "Recover password" },
    Password: { pt: "Senha", en: "Password" },
    ConfirmPassword: { pt: "Confirme a Senha", en: "Confirm password" },
    Email: { pt: "E-mail", en: "E-mail" },
    DontHave: { pt: "Não tem conta? Cadastre-se", en: "Don't have an account? Register" },
    Incorrect: { pt: "O usuário ou senha estão incorretos", en: "The username or password is incorrect" },
    DontExist: { pt: "A conta que esta tentando acessar não existe", en: "The account you are trying to access does not exist" },
    AlreadyExist: { pt: "Já existe um usuário cadastrado com esse email", en: "There is already a registered user with this email" },
  },
  Menu: {
    Home: { pt: "Home", en: "Home" },
    Quotation: { pt: "Cotação", en: "Quotation" },
    Tracking: { pt: "Rastreamento", en: "Tracking" },
    Documents: { pt: "Documentos", en: "Documents" },
    MyDeliveries: { pt: "Meus pedidos", en: "My deliveries" },
    Billing: { pt: "Cobrança", en: "Billing" },
    AddressList: { pt: "Livro de endereços", en: "Address List" },
    Profile: { pt: "Perfil", en: "Profile" },
    Company: { pt: "Empresa", en: "Company" },
    Help: { pt: "Ajuda", en: "Help" },
    Suport: { pt: "Suporte", en: "Suport" },
    Terms: { pt: "Termos", en: "Terms" },
  },
  Register: {
    Title: { pt: "Cadastro", en: "Register" },
    Type: { pt: "Tipo de conta", en: "Account Type" },
    Success: { pt: "Cadastro efetuado com sucesso", en: "Registration successfully Complete" },
    StrongPassword: { pt: "A senha precisa de ao menos 1 caracter especial, letra maiúscula, minúscula e número", en: "The password needs at least 1 special character, uppercase letter, lowercase letter and number" },
    CompanyExist: { pt: "Essa empresa já está cadastrada na plataforma. Nossa equipe vai revisar os dados e aprovar seu cadastro.", en: "This company is already registered on the platform. Our team will review the data and approve your registration." },
    AccountInformation: { pt: "Informações da conta", en: "Account information" },
    RegisterCompany: { pt: "Cadastrar empresa", en: "Register company" },
    AcceptTerms: { pt: "Li e concordo com os Termos de uso, Política de Privacidade, ciente de que meus dados pessoais serão utilizados exclusivamente para os fins dispostos nestes documentos.", en: "I have read and agree to the Terms of Use, Privacy Policy, aware that my personal data will be used exclusively for the purposes set out in these documents." },
  },
  Payment: {
    PaymentType: { pt: "Forma de pagamento", en: "Form of payment" },
    DefaultPayment: { pt: "Padrão (PIX e Cartão de crédito)", en: "Credit Card" },
    Billed: { pt: "Faturamento", en: "Billing" },
    InvalidCvv: { pt: "Código de segurança inválido", en: "Invalid security code" },
    InvalidCardNumber: { pt: "Número do cartão é inválido", en: "Invalid credit card number" },
    SelectOne: { pt: "Selecione um cartão para prosseguir", en: "Select a card to proceed" },
    Success: { pt: "Pagamento processado", en: "Payment processed" },
    EnterCreditCard: { pt: "Digite o número do cartão", en: "Enter card number" },
    ExpirationMonth: { pt: "Mês de Vencimento", en: "Expiration Month" },
    ExpirationYear: { pt: "Ano de Vencimento", en: "Expiration Year" },
    Expiration: { pt: "Vencimento", en: "Expiration" },
    Brand: { pt: "Bandeira", en: "Brand" },
    Holder: { pt: "Nome do proprietário do cartão", en: "Card owner name" },
    HolderDoc: { pt: "CPF ou CNPJ do proprietário do cartão", en: "Id of the card owner" },
    Cards: { pt: "Cartões", en: "Credit Cards" },
    Card: { pt: "Cartão de crédito", en: "Credit Card" },
    AddCard: { pt: "Adicionar Cartão", en: "Add Credit Card" },
    CardNumber: { pt: "Nº do cartão", en: "Card number" },
    ConfirmCode: { pt: "Confirme o CVV", en: "Confirm CVV" },
  },
  Select: { pt: "Selecione", en: "Select" },
  Name: { pt: "Nome", en: "Name" },
  Surname: { pt: "Sobrenome", en: "Surname" },
  Phone: { pt: "Celular", en: "Cell phone" },
  Id: { pt: "CPF", en: "ID" },
  ContactEmail: { pt: "Email de contato", en: "Contact Email" },
  Limit: { pt: "Excedido tempo limite de acesso, verifique o status da sua conexão", en: "Access timeout exceeded, check your connection status" },
  Prohibited: { pt: "Acesso proibido", en: "Access prohibited" },
  Unknown: { pt: "Ocorreu um erro desconhecido", en: "An unknown error has occurred" },
  Internal: { pt: "Erro interno de servidor, tente novamente mais tarde ou entre em contato com suporte.", en: "Internal server error, please try again later or contact support." },
  DontExist: { pt: "Elemento não existe", en: "Does not exist" },
  Conflict: { pt: "Esse item já existe", en: "This item already exists" },
  Largest: { pt: "Arquivo grande demais", en: "File too big" },
  Unsuported: { pt: "Formato de arquivo não suportado", en: "Unsupported file format" },
  Advance: { pt: "Avançar", en: "Advance" },
  GoBack: { pt: "Voltar", en: "Go back" },
  Redefine: { pt: "Redefinir", en: "Reset" },
  HaveAnAccount: { pt: "Já tenho uma conta", en: "I already have an account" },
  PostalCode: { pt: "CEP", en: "Postal code" },
  Address: { pt: "Endereço", en: "Address" },
  OriginAddress: { pt: "Endereço de origem", en: "Origin address" },
  DestinationAddress: { pt: "Endereço de entrega", en: "Delivery address" },
  Number: { pt: "Número", en: "Number" },
  Complement: { pt: "Complemento", en: "Complement" },
  Country: { pt: "País", en: "Country" },
  State: { pt: "Estado", en: "State" },
  City: { pt: "Cidade", en: "City" },
  Neighborhood: { pt: "Bairro", en: "Neighborhood" },
  RecipientName: { pt: "Nome do destinatário", en: "Recipient's name" },
  SendersName: { pt: "Nome do Remetente", en: "Sender's name" },
  MandatoryNeighborhood: { pt: "Na entrega nacional é obrigatório o preenchimento do bairro", en: "For Brazilian delivery, it is mandatory to fill in the neighborhood" },
  BoxName: { pt: "Nome da caixa (para sua identificação)", en: "Box name (for your identification)" },
  BoxHeight: { pt: "Altura da caixa (cm)", en: "Box height (cm)" },
  BoxWidth: { pt: "Largura da caixa (cm)", en: "Box width (cm)" },
  BoxDepth: { pt: "Profundidade da caixa (cm)", en: "Box depth (cm)" },
  BoxWeight: { pt: "Peso da caixa (Kg)", en: "Box weight (Kg)" },
  BoxContent: { pt: "Qual é o valor total do conteúdo da caixa?", en: "What is the total value of the contents of the box?" },
  BoxInsurance: { pt: "O item será assegurado no valor definido por você logo acima.", en: "The item will be insured at the value defined by you above." },
  Add: { pt: "Adicionar", en: "Add" },
  Boxes: { pt: "Caixas", en: "Boxes" },
  AddBox: { pt: " Adicionar caixa / envelope", en: "Add box / envelope" },
  BoxDefinition: { pt: " Definições da caixa", en: "Box settings" },
  Duplicate: { pt: " Duplicar", en: "Duplicate" },
  Delete: { pt: "Excluir", en: "Delete" },
  Content: { pt: "Conteúdo da caixa", en: "Box content" },
  Edit: { pt: "Editar", en: "Edit" },
  Height: { pt: "Altura", en: "Height" },
  Width: { pt: "Largura", en: "Width" },
  Value: { pt: "Valor", en: "Value" },
  Weigth: { pt: "Peso", en: "Weigth" },
  Depth: { pt: "Comprimento", en: "Depth" },
  PhysicalPerson: { pt: "Pessoa física", en: "Physical person" },
  LegalPerson: { pt: "Pessoa jurídica", en: "Legal person" },
  Tracking: { pt: "Rastreamento", en: "Tracking" },
  Resume: { pt: "Resumo", en: "Summary" },
  NationalDelivery: { pt: "Entrega nacional", en: "Brazilian Delivery" },
  InternationalDelivery: { pt: "Entrega internacional", en: "International delivery" },
  Actives: { pt: "Entregas ativas", en: "Active deliveries" },
  ZeroDeliveries: { pt: "Você não fez nenhum pedido.", en: "You haven't made any requests." },
  StartDelivery: { pt: "Selecione entrega nacional ou internacional acima para começar.", en: "Select domestic or international delivery above to get started" },
  DeliveryCode: { pt: "Cód. de entrega", en: "Delivery Code" },
  ProcessingDocs: { pt: "Os documentos estão sendo processados, estarão disponíveis em breve", en: "Documents are being processed and will be available soon" },
  Status: {
    Configuring: { pt: "Em coleta", en: "Configuring" },
    Processing: { pt: "Processando", en: "Processing" },
    Ongoing: { pt: "Em andamento", en: "Ongoing" },
    Error: { pt: "Erro", en: "Error" },
    Canceled: { pt: "Cancelada", en: "Canceled" },
    Returning: { pt: "Retornando", en: "Returning" },
    Returned: { pt: "Devolvido", en: "Returned" },
    Delivered: { pt: "Entregue", en: "Delivered" },
  },
  Client: { pt: "Cliente", en: "Client" },
  Term: { pt: "Prazo", en: "Term" },
  CollectionDate: { pt: "Data da coleta", en: "Collection date" },
  CollectionInitialTime: { pt: "Coletar a partir das", en: "Collect from" },
  CollectionFinalTime: { pt: "Coletar até ás", en: "Collect up to" },
  Days: { pt: "Dias", en: "Days" },
  CollectionInstructions: { pt: "Instruções da coleta", en: "Collection instructions" },
  Package: { pt: "Pacote", en: "Package" },
  Origin: { pt: "Origem", en: "Origin" },
  Destination: { pt: "Destino", en: "Destination" },
  ObjectCode: { pt: "Cód de objeto", en: "Object code" },
  RequestDate: { pt: "Data do pedido", en: "Request Date" },
  StartDate: { pt: "Data de início", en: "Start date" },
  EndDate: { pt: "Data fim", en: "End date" },
  ClearFields: { pt: "Limpar campos", en: "Clear fields" },
  CustomsDefinitions: { pt: "Definições alfandegárias", en: "Customs definitions" },
  Insurance: { pt: "Seguro?", en: "Insurance?" },
  WhosGonaPaysTaxes: { pt: "Quem vai pagar o imposto?", en: "Who will pay the tax?" },
  ProductType: { pt: "Qual o tipo de produto?", en: "What type of product?" },
  Yes: { pt: "Sim", en: "Yes" },
  No: { pt: "Não", en: "Not" },
  Recipient: { pt: "Destinatário", en: "Recipient" },
  Sender: { pt: "Remetente", en: "Sender" },
  Taxes: { pt: "Impostos", en: "Taxes" },
  Freight: { pt: "Frete", en: "Freight" },
  Services: { pt: "Serviço", en: "Services" },
  DeliveryDate: { pt: "Entrega prevista", en: "Delivery Date" },
  Cheaper: { pt: "Mais barato", en: "Cheaper" },
  Faster: { pt: "Mais rápido", en: "Faster" },
  Details: { pt: "Detalhes", en: "Details" },
  SelectCarrier: { pt: "Selecione uma transportadora", en: "Select a carrier" },
  MissingSender: { pt: "Esta faltando dados do responsavel pela coleta", en: "Data from the person responsible for collection is missing" },
  MissingReceiver: { pt: "Esta faltando dados do responsavel pela entrega", en: "Data from the person responsible for delivery is missing" },
  ConfirmRequest: { pt: "Confirmar pedido", en: "Confirm order" },
  RegisterResponsible: { pt: "Cadastre os responsáveis", en: "Register those responsible" },
  Responsible: { pt: "Responsável", en: "Responsible" },
  Invoice: { pt: "Nota fiscal", en: "Invoice" },
  ViewInvoice: { pt: "Ver fatura", en: "View invoice" },
  BillingPeriod: { pt: "Período de cobrança", en: "Billing period" },
  DueDate: { pt: "Data da fatura", en: "Due Date" },
  BillingEnabled: { pt: "Opção de faturamento habilitada", en: "Billing option enabled" },
  BillingDisabled: { pt: "Opção de faturamento desabilitado", en: "Billing option disabled" },
  BillingEnabledPhrase: { pt: "Faça um pedido para começar", en: "Place an order to get started" },
  BillingDisabledPhrase: { pt: "Entre em contato com a BeeMove para ativar", en: "Contact BeeMove to activate" },
  Invoices: { pt: "Faturas", en: "Invoices" },
  Type: { pt: "Tipo", en: "Type" },
  AddressBook: { pt: "Livro de endereços", en: "Address Book" },
  Open: { pt: "Abrir", en: "Open" },
  DontHaveAddress: { pt: "Você não tem nenhum endereço cadastrado", en: "You do not have any registered address" },
  RepeteDelivery: { pt: "Recriar remessa", en: "Recreate shipment" },
  Leave: { pt: "Tem certeza que deseja sair?", en: "Are you sure you want to quit?" },
  OrderDone: { pt: "Seu pedido foi finalizado! A documentação sendo emitida", en: "Your order has been completed! Documentation being issued" },
  SupportTitle: { pt: "Suporte e Ajuda", en: "Support and Help" },
  SelectCurrency: { pt: "Selecionar moeda", en: "Select currency" },
  CannotFindCurrency: { pt: "Não foi possível consultar a cotação das moedas", en: "Unable to check currency rates" },
  PackageNotReady: { pt: "Pacote não está pronto", en: "Package not ready" },
  RatesTooHigh: { pt: "Taxas muito altas", en: "Rates too high" },
  TransitTimeTooSlow: { pt: "Tempo de trânsito muito lento", en: "Transit time too slow" },
  TakeToServiceCenterOrDropBox: { pt: "Leve ao centro de serviço ou caixa de depósito", en: "Take to service center or drop box" },
  CommitmentTimeNotMet: { pt: "Prazo de compromisso não cumprido", en: "Commitment time not met" },
  ReasonNotGiven: { pt: "Sem motivo", en: "Reason not given" },
  Other: { pt: "Outro", en: "Other" },
  PickupModified: { pt: "Coleta modificada", en: "Pickup modifie" },
};

export default function Translate(message) {
  const lang = Storage.getLang();
  if (lang == null) {
    Storage.setLang("pt");
  } else {
    return message[lang];
  }
}

export function ChangeLanguage() {
  return (
    <span>
      <button className="btn btn-sm btn-dark" onClick={() => Storage.setLang("pt") | window.location.reload()}>Português</button>
      <button className="btn btn-sm btn-dark ml-2 mr-2" onClick={() => Storage.setLang("en") | window.location.reload()}>English</button>
    </span>
  )
}